import PropTypes from "prop-types";
import React from "react";
import { priceType } from "../../../common/types";
import { SEGMENT_BZA, SEGMENT_CMC } from "../../constants";

export function HeroPackage({
	label,
	title = "Subscription",
	subtitle,
	features,
	price,
	singlePackage,
	subscribeLinkUrl,
}) {
	const featuresList = features && (
		<ul className="ticks ticks--small">
			{features.map((feature, index) => (
				<li key={index}>{feature}</li>
			))}
		</ul>
	);

	const buttons = (
		<div className="btn-group btn-group-vertical">
			<a href={subscribeLinkUrl} className="btn btn--primary">
				{singlePackage ? "Free 14-day trial" : "Subscribe now"}
			</a>
			{singlePackage && (
				<a href={subscribeLinkUrl} className="btn btn--secondary">
					See pricing options
				</a>
			)}
		</div>
	);

	const priceTotal = singlePackage ? (
		`From ${price} €/Year`
	) : (
		<>
			<span className="value">{price}</span>
			<span className="currency">€</span>/year
		</>
	);

	return (
		<div className="subscription">
			{label && (
				<header>
					<span>{label}</span>
				</header>
			)}
			<div className="content typography">
				<p className="title">{title}</p>
				{subtitle && <p className="subtitle">{subtitle}</p>}
				<p className="price">{priceTotal}</p>
				{featuresList}
				{buttons}
			</div>
		</div>
	);
}

HeroPackage.propTypes = {
	label: PropTypes.oneOf([SEGMENT_CMC, SEGMENT_BZA, "Most Popular"]),
	title: PropTypes.string,
	subtitle: PropTypes.string,
	features: PropTypes.arrayOf(PropTypes.string),
	price: priceType.isRequired,
	singlePackage: PropTypes.bool.isRequired,
	subscribeLinkUrl: PropTypes.string.isRequired,
};
